import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { DeleteOutline } from '@material-ui/icons';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
    backgroundColor: lighten(theme.palette.facet.red, 0.8),
    '&:hover': {
      backgroundColor: lighten(theme.palette.facet.red, 0.6),
    },
  },
  icon: {
    color: theme.palette.facet.red,
    '&:hover': {
      color: darken(theme.palette.facet.red, 0.2),
    },
  },
}));

const DeleteButton = ({
  onClick,
  title = 'Delete',
  test = 'delete-button',
  disabled = false,
  size = 'medium',
}) => {
  const classes = useStyles();

  return (
    <IconButton
      className={classes.root}
      icon={DeleteOutline}
      onClick={onClick}
      title={title}
      color={'red'}
      test={test}
      size={size}
      disabled={disabled}
    />
  );
};

export default DeleteButton;
